import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { accountLatestWipStatementQueryKey } from "./account.keys";

export const useFetchAccountLatestWipStatement = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: accountLatestWipStatementQueryKey(accountId),
		queryFn: async () => {
			try {
				return await get<Dtos.WipStatement.Get.Response>(
					`/v2/surety/accounts/${accountId}/work-in-progress-statements/latest`,
				);
			} catch (error) {
				if (error instanceof ApiError && error.statusCode === 404) {
					return null;
				}
				throw error;
			}
		},
	});

	return {
		latestWipStatement: data,
		latestWipStatementError: error,
		latestWipStatementIsLoading: isLoading,
	};
};
